import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import loc from 'sources/locale/loc';
import { BaseImage, Button } from 'components/controls';
import UsersApi from 'api/UsersApi';
import styles from './AdminUsersList.scss';
import UserShape from '../../../sources/shapes/UserShape';

const USER_ACTIONS = {
  block: UsersApi.blockUser.bind(UsersApi),
  unblock: UsersApi.unblockUser.bind(UsersApi),
};

function AdminUsersListItem(props) {
  const {
    item: {
      id,
      name,
      email,
      birthDate,
      gender,
      genderPreferences,
      numberOfReports,
      convertedUrl,
      isBlocked,
    },
    onUpdateItem,
    item,
  } = props;

  const [state, setState] = useState({
    error: null,
    processing: false,
    result: null,
  });

  const handleManageUser = action => async () => {
    setState({
      ...state,
      processing: true,
    });

    try {
      const userAction = USER_ACTIONS[action];

      if (!userAction) {
        return;
      }

      const result = await userAction(id);

      setState({
        ...state,
        result,
        processing: false,
      });

      onUpdateItem({ ...item, isBlocked: action === 'block' });
    } catch (err) {
      setState({
        ...state,
        err,
        processing: false,
      });
    }
  };

  const renderActionButton = () => {
    return !isBlocked ? (
      <Button
        label={loc('block')}
        onClick={handleManageUser('block')}
        size="small"
        color="secondary"
        variant="filled"
        className={styles.button}
      />
    ) : (
      <Button
        label={loc('unblock')}
        onClick={handleManageUser('unblock')}
        size="small"
        color="secondary"
        variant="filled"
        className={styles.button}
      />
    );
  };

  return (
    <li className={classnames(styles.listItem, styles.container)}>
      <div className={styles.avatar}>
        <BaseImage
          src={convertedUrl}
          alt="avatar"
          className={styles.avatarImage}
        />
      </div>
      <div className={styles.name}>{name}</div>
      <div className={styles.email}>{email}</div>
      <div className={styles.dob}>{moment(birthDate).format('MM/DD/YYYY')}</div>
      <div className={styles.gender}>{loc(gender)}</div>
      <div className={styles.genderPreferences}>{loc(genderPreferences)}</div>
      <div className={styles.reports}>{numberOfReports}</div>
      <div className={styles.actions}>{renderActionButton()}</div>
    </li>
  );
}

AdminUsersListItem.propTypes = {
  item: UserShape,
  onUpdateItem: PropTypes.func.isRequired,
};

AdminUsersListItem.defaultProps = {
  item: {},
};

export default AdminUsersListItem;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersList/AdminUsersListItem.jsx